import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: any) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <div>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          key={src}
          aria-label={src}
        >
          <SvgIcon src={src} width="25px" height="25px" />
        </a>
      </div>
    );
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            {/* <Col lg={4} md={4} sm={12} xs={12}>
              <Language>{t("Address")}</Language>
              <Para>Rancho Santa Margarita</Para>
              <Para>2131 Elk Street</Para>
              <Para>California</Para>
            </Col> */}
            <Row>
              <Col >
                <Title>{t("footer.links")}</Title>
                <Large left="true" to="/download">
                  {t("header.download")}
                </Large>
                <Large left="true" to="/career">
                  {t("header.career")}
                </Large>
                <Large left="true" to="/contact">
                  {t("header.contact")}
                </Large>
                <Large left="true" to="/register-business">
                  {t("header.registerYourBusiness")}
                </Large>
              </Col>
              <Col>
                <Title>{t("footer.company")}</Title>
                <Large left="true" to="/about">
                  {t("footer.about")}
                </Large>
                <Large left="true" to="/privacy">
                  {t("footer.privacy")}
                </Large>
                <Large left="true" to="/terms-and-conditions">
                  {t("footer.terms")}
                </Large>
              </Col>
            </Row>
            <Col lg={4} md={4} sm={12} xs={12}>
              <Title >{t("Language")}</Title>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon
                    src="united-states.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("it")}>
                  <SvgIcon
                    src="italy.svg"
                    aria-label="homepage"
                    width="30px"
                    height="30px"
                  />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "1rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
              <SvgIcon src="logo.svg" width="64px" height="64px" />
                <SvgIcon
                  src="logo_text.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink> {/* //TODO Fill with correct infos */}
            <Para>Ciardu S.n.c.</Para> 
            <FooterContainer>
              {/* <SocialLink
                href="https://github.com/Adrinlol/create-react-app-adrinlol" //TODO Facebook
                src="github.svg"
              />
              <SocialLink
                href="https://twitter.com/Adrinlolx" //TODO Insta
                src="twitter.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/in/lasha-kakabadze/" //TODO Twitter
                src="linkedin.svg"
              /> */}
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
